import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = { key: 0 }

import { computed, useSlots } from "vue";
import { TranslateResult } from "vue-i18n";
import { isExistSlot } from "@/plugins/helpers";
import { useRouter } from "vue-router";

interface Props {
  to?: {
    name?: string | TranslateResult;
    params?: {
      id?: string | number;
    };
  };
  text?: string | TranslateResult;
  tooltip?: string | number;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VLink',
  props: {
    to: { default: () => {
    return {};
  } },
    text: { default: "" },
    tooltip: { default: "" },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const slots = useSlots();
const router = useRouter();

const props = __props;

const tippyConfig = computed(() => {
  return {
    onShow: () => !!props.tooltip && !props.disabled,
  };
});

const isDisabledLink = computed(() => {
  return props.disabled ? "span" : "router-link";
});

const wrapperClasses = computed(() => {
  return { disabled: props.disabled, "slot-content": isExistSlot("link-content", slots) };
});

const onClick = () => {
  if (!props.disabled) {
    emit("click");
  }
};

const onTouchRouterLink = (to) => {
  return (event) => {
    if (!event.button) onClickRouterLink(to);
  };
};

const onClickRouterLink = (to) => {
  if (!props.disabled) {
    router.push(to).catch(() => ({}));
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!
  const _directive_tippy = _resolveDirective("tippy")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    content: _ctx.tooltip,
    class: _normalizeClass([wrapperClasses.value, "link-wrapper"]),
    onClick: onClick
  }, [
    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(isDisabledLink.value), {
      to: _ctx.to,
      class: "link",
      onClickCapture: _cache[0] || (_cache[0] = ($event: any) => (onClickRouterLink(_ctx.to)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
        (_unref(isExistSlot)('link-content', _unref(slots)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "link-content")
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 3
    }, 40, ["to"])), [
      [_directive_touch, onTouchRouterLink(_ctx.to)]
    ])
  ], 10, _hoisted_1)), [
    [_directive_tippy, tippyConfig.value]
  ])
}
}

})